if (PJQ.app.module === PJQ.constants.modules.PROJECTWALLADMIN) {
	PJQ.app.addOldRoutes([
		{
			route: '',
			name: 'default',
			callback: function () {
				InitProjectWallAdmin();
			}
		}
	]);
}

PJQ.modules.pjqProjectWall = {
	routes: [
		{
			route: 'projects/:projectId',
			name: 'project',
			callback: function (projectId) {
				PJQ.modules.pjqProjectWall.initProjectWallAdmin(projectId);
			}
		},
		{
			route: 'projects/:projectId/punchlists/:punchListItemId',
			name: 'punchListItemOld',
			callback: function (projectId, punchListItemId) {
				window.punchListItemId = parseInt(punchListItemId);
				PJQ.modules.pjqProjectWall.initProjectWallAdmin(projectId);
			}
		},
		{
			route: 'projects/:projectId/dailyreports/:date',
			name: 'dailyReportDate',
			callback: function (projectId, date) {
				window.dailyReportDate = date;
				PJQ.modules.pjqProjectWall.initProjectWallAdmin(projectId);
			}
		}
	],
	oldRoutes: [
		{
			route: "?projectid",
			callback: function (projectId) {
				PJQ.modules.pjqProjectWall.initProjectWallAdmin(projectId);
			}
		}
	],
	initProjectWallAdmin: function (projectId, options = {}) {
		window.pjqIsNewProjContainer = false;
		window.pjqWallContext = 'project';
		window.pjqIsNewProject = !(projectId > 0);

		window.ValidateEmail = function (email) {
			return PJQ.helpers.validators.validateEmail(email);
		};
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'session'
				},
				{
					endpoint: 'project',
					value: projectId
				}
			])
		}).get().done(_.bind(function () {
			PJQ.app.session.project = new PJQ.models.projects.Project({
				projectId: projectId
			});
			if(PJQ.app.session.project.id > 0){
				PJQ.app.session.project.fetch({
					success: function(){
						InitProjectWallAdmin();
					}
				});
			}
			else{
				InitProjectWallAdmin();
			}
		}, this)).fail(function () {
			//todo: fail
		});
	}
};

function initDailyReports() {
	PJQ.app.DailyReportsManagement = new PJQ.views.dailyReports.DailyReportsNavigator({
		el: $('#daily-reports'),
		project: PJQ.app.session.project,
		date: PJQ.helpers.dateHelpers.tryParseDateString(window.dailyReportDate)
	});
	window.dailyReportDate = null;
}

function initPunchlistsAdmin() {
	if (!PJQ.app.PunchlistView) {
		let punchlistItems = new PJQ.collections.punchlists.PunchlistItems(null, {
			project: PJQ.app.session.project
		});
		punchlistItems.fetch({
			success: function () {
				PJQ.app.PunchlistView = new PJQ.views.punchlists.PunchlistView({
					el: '#project-punchlists',
					collection: punchlistItems,
					project: PJQ.app.session.project,
					punchListItemId: window.punchListItemId
				});

				window.punchListItemId = null;
			}
		});
	}
}